import { HeaderWrapper } from "./styles";
import { Logo } from "components/Logo";
import { useAuth } from "contexts/AuthContext";
import { Link } from "react-router-dom";
import { useProSidebar } from "react-pro-sidebar";
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import React, { useState, useRef } from 'react';
import { useLogout as logout } from "hooks/useLogout";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import PersonIcon from '@mui/icons-material/Person';
import IconButton from "@mui/material/IconButton";
import { Typography } from "@mui/material";

interface HeaderProps {
    homePath?: string;
    showSidebarToggle?: boolean;
}

export function Header({ homePath = "/home", showSidebarToggle = true }: HeaderProps) {
    const { username } = useAuth()
    let name = (username.split(".")[0] || "usuário")
    name = name.charAt(0).toUpperCase() + name.slice(1)
    const { collapseSidebar, collapsed } = useProSidebar()
    const [showPopup, setShowPopup] = useState(false);
    const userWrapperRef = useRef<HTMLButtonElement>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleLogout = () => {
        logout();
        setShowPopup(false);
    };

    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    // Fecha o popup ao clicar fora
    React.useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (userWrapperRef.current && !userWrapperRef.current.contains(event.target as Node)) {
                setShowPopup(false);
            }
        }
        if (showPopup) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showPopup]);

    return (
        <HeaderWrapper className="header">
            {showSidebarToggle && (
                <div className="sidebarToggle">
                    <button onClick={(e) => {
                        collapseSidebar(!collapsed)
                    }}>
                        <MenuIcon sx={{ color: '#757575' }} />
                    </button>
                </div>
            )}
            <Link to={homePath}>
                <Logo />
            </Link>
            <IconButton
                ref={userWrapperRef}
                onClick={handleMenuOpen}
                sx={{
                    borderRadius: '10%',
                }}
            >
                <div className="userWrapper">
                    <span className="avatar">
                        <PersonIcon fontSize="small" />
                    </span>
                    <Typography variant="body1" sx={{ fontWeight: '600', color: '#353535' }}>{name}</Typography>
                </div>
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    elevation: 2,
                    sx: { minWidth: 150 }
                }}
            >
                <MenuItem
                    onClick={() => {
                        handleLogout();
                        handleMenuClose();
                    }}
                >
                    <ListItemIcon>
                        <LogoutIcon fontSize="small" />
                    </ListItemIcon>
                    Deslogar
                </MenuItem>
            </Menu>
        </HeaderWrapper>
    )
}
